/**
* Component: basicDetailsReducer.js
* Description: This reducer manages the state related to basic details of the asset.
*/

const initialState = {
  rentalStatus: { label: "No", key: "option2", default: true }, //setting the default value
  tcNo: '',
  tcOldNo: '',
  assetClassification: {key: 'option1', id: 1, label: 'Asset', isloanerasset: false}, //setting the default value for asset classification when rentalStatus is No
  financeAssetNo: '',
  assetDescription: '',
  typecode: '',
  typeCodeDescription: '',
  locationName: '',
  locationNo: '',
  userDepartment: '',
  departmentDescription: '',
  criticality: '',
  workGroup: '',
  ppmRequired: { label: "Yes", key: "option1", default: true },//setting the default value
  ppmStatus: { label: "In House", key: "option2", isvisible : true,id: 2 }, //setting the default value
  parentAssestNo: '',
  description: '',
  reason: '',
  isauthorized: false,
  assetValue:'',
  oldAssetNo:"",
};

const basicDetailsReducer = (state = initialState, action) => {

  switch (action.type) {
    case 'UPDATE_BASIC_DETAILS':
      return {
        ...state,
        ...action.payload,
      };
    case 'CLEAR_BASIC_DETAILS':
      return {};
    default:
      return state;
  }
};

export default basicDetailsReducer;
